export function mapServerData(firstElement, res, data) {
    return {
        uslId: firstElement ? firstElement.kcpGroup.usl.id : data.usl.id,
        foId: firstElement ? firstElement.fo.id : data.fo.id,
        data: firstElement ? res : [],
    }
}